// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t1si2","spinner":"styles_spinner__iu41M"};